export const screen = {
  mobile: 380,
  tablet: 978,
  desktop: 1100,
};
